import React from "react";

const PaperDarkBG = ({ children, className = "", fullHeight = false}) => {
  return (
    <div
      className={`${fullHeight ? "min-h-screen" : ""} w-full text-[#EFEBDC]  bg-[#151515] ${className}`}
    >
      {children}
    </div>
  );
};

export default PaperDarkBG;
